module.exports = __webpack_public_path__ + "media/images/restaurant vegan-496fc267dd46326848a6613af1ddf33d.svg";